import { render, staticRenderFns } from "./SLD.vue?vue&type=template&id=67a825b8"
import script from "./SLD.vue?vue&type=script&lang=js"
export * from "./SLD.vue?vue&type=script&lang=js"
import style0 from "./SLD.vue?vue&type=style&index=0&id=67a825b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports